import { render, staticRenderFns } from "./24welHeader.vue?vue&type=template&id=300136bf&scoped=true&"
import script from "./24welHeader.vue?vue&type=script&lang=js&"
export * from "./24welHeader.vue?vue&type=script&lang=js&"
import style0 from "./24welHeader.vue?vue&type=style&index=0&id=300136bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300136bf",
  null
  
)

export default component.exports